import { Modal } from 'antd';

let isLoggingOut = false;

export function handleSessionExpired(logoutCallback) {
  if (isLoggingOut) return;

  isLoggingOut = true;

  Modal.info({
    title: 'Sessione scaduta',
    content: 'Clicca "Ok" per effettuare nuovamente l’accesso.',
    okText: 'Ok',
    centered: true,
    onOk: () => {
      logoutCallback();
    },
  });
}